import { ReactNode } from 'react';
import styles from './EmptyState.module.css';

interface EmptyStateProps {
	icon?: ReactNode;
	title: string;
	description?: string;
}

export const EmptyState = ({ icon, title, description }: EmptyStateProps) => {
	return (
		<div className={styles.emptyState}>
			{icon && <div className={styles.emptyStateIcon}>{icon}</div>}
			<h4 className={styles.emptyStateTitle}>{title}</h4>
			{description && <p className={styles.emptyStateDescription}>{description}</p>}
		</div>
	);
};
